import values from "../values";

import { Navigate, Route, Routes } from "react-router-dom";

import ProtectedRoute from "./ProtectedRoute";
import {
  LoginAdminScreen,
  LoginScreen,
  NotFound,
  SignUpScreen,
} from "../../panel/screen";
import CompanyRoute from "../../panel/routes/company.route";
import MunicipalityRoute from "../../panel/routes/municipality.route";

import AdministratorsRoute from "../../panel/routes/administrator.route";
import utils from "../utils";
import Cookies from "js-cookie";
import { useQuery } from "react-query";
import api from "../api";
import Context from "../context";

const PanelRoute = () => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(values?.constants?.USER?.TYPE)
  );
  const userInfo = useQuery(
    [values.useQueryKeys.userInfo],
    () => api.getMethod.common.findMe(),
    { enabled: userType !== undefined }
  );

  return (
    <Context.AppContext.Provider value={{ userInfo }}>
      <Routes>
        <Route path="/" element={<Navigate to={"panel/login"} />} />

        <Route
          path="/administrator/*"
          element={<ProtectedRoute Component={<AdministratorsRoute />} />}
        />
        <Route
          path="/company/*"
          element={<ProtectedRoute Component={<CompanyRoute />} />}
        />
        <Route
          path="/municipality/*"
          element={<ProtectedRoute Component={<MunicipalityRoute />} />}
        />
        <Route path="/login/*" element={<LoginScreen />} />
        <Route path="/sign-up/*" element={<SignUpScreen />} />
        <Route path="/login-admin/*" element={<LoginAdminScreen />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Context.AppContext.Provider>
  );
};

export default PanelRoute;
